<ion-grid appScrollbarTheme fullscreen class="aadhar-concen-wrap">
  <ion-row>
    <ion-col size="12" class="ion-text-end">
      <ion-icon class="custom-close" (click)="dismissModal()"></ion-icon>
    </ion-col>
  </ion-row>
  <h3 class="pageSubTitle ion-text-center">Consent Notice</h3>
  <ion-row>
    <ion-col size="12">
      <p>
        I, the data principal (Pregnant Woman/Parent/Guardian), understand that
        U-WIN portal may collect my and/or my child's personal sensitive
        information (name, child's name, date of birth, gender, ID number,
        mobile number etc.) strictly to register and manage vaccination
        appointments, vaccine administration, database management and
        certificate generation.
      </p>

      <p>
        1. I understand that my and/or my child's personal data may be collected
        only with my valid consent, and that it may be used or processed only in
        accordance with the
        <a
          href="https://www.meity.gov.in/static/uploads/2024/06/2bf1f0e9f04e6fb4f8fef35e82c42aa5.pdf"
          target="_blank"
          >Digital Personal Data Protection Act, 2023</a
        >.
      </p>

      <p>
        2. I understand that I have certain rights that I enjoy as a data
        principal over my and/or my child's personal data, in relation to its
        collection, use and processing. These rights relate to confirmation and
        access, correction and erasure, objection of disclosure, and portability
        of such personal data. These rights are available to me in the manner
        set out in the DPDP Act, 2023 and the
        <a [href]="ENV.AppRedirectUrls.mainPage + '/privacy-policy'"
          >Privacy Policy</a
        >
        issued by Ministry of Health and Family Welfare, Government of India.
      </p>

      <p>
        3. I understand that I can withdraw my consent for all or any of the
        purposes at any time by and on withdrawal of my consent, the processing
        of my shared information will stop, however, any personal data already
        been processed shall remain unaffected on such withdrawal of consent.
      </p>

      <p>
        4. I am also aware that my and/or my child's personal information may be
        used and/or shared for purposes of providing services/benefits as may be
        notified by Government of India.
      </p>

      <p>
        5. I am aware about the risk and benefits of the vaccine(s) being given.
        I consent to the vaccination(s) being given either to me or to my child.
      </p>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" class="ion-text-end">
      <ion-item lines="none" class="ion-no-padding">
        <ion-checkbox
          [(ngModel)]="readAllConsent"
          label-placement="end"
          justify="start"
          ><b class="ion-text-wrap">I have read the consent notice provided above.</b>
        </ion-checkbox>
      </ion-item>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" class="ion-text-end">
      <ion-item lines="none" class="ion-no-padding ion-hide-md-down">
        <ion-button
          type="button"
          class="primaryBtn"          
          expand="block"
          slot="end"
          (click)="isConsentChecked()"
          >{{ "Agree" | translate }}
        </ion-button>        
      </ion-item>
      <!-- button for mobile       -->
      <p class="ion-hide-md-up">        
        <ion-button
          type="button"
          class="primaryBtn"          
          expand="block"
          (click)="isConsentChecked()"
          >{{ "Agree" | translate }}
        </ion-button>
      </p>      
    </ion-col></ion-row
  >
  <!-- <ion-row>
    <ion-col size="12" class="ion-text-end">
      <p class="ion-hide-md-down">
        <ion-button class="primaryBtn" (click)="dismissModal()"
          >Close</ion-button
        >
      </p>
      <p class="ion-hide-md-up">
        <ion-button
          class="primaryBtn"
          expand="full"
          shape="round"
          (click)="dismissModal()"
          >Close</ion-button
        >
      </p>
    </ion-col>
  </ion-row> -->
</ion-grid>
